import { useState } from "react";
import PortalHeader from "./PortalHeader";
import PortalSidebar from "./PortalSidebar";
import PortalRightPanel from "./PortalRightPanel";
import MobileBottomNav from "./MobileBottomNav";
import PhoneVerifyModal from "../components/PhoneVerifyModal";
import PharmacySelector from "../home/PharmacySelector";
import "../styles/portal.css";

export default function PortalLayout({ children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="portal-layout">

      <PortalHeader
        onMenuClick={() => setDrawerOpen(true)}
      />

      <div className="portal-body">

        {/* Desktop sidebar — always visible on wide screens */}
        <PortalSidebar />

        {/* Mobile drawer overlay */}
        {drawerOpen && (
          <div
            className="sidebar-overlay"
            style={{ display: "block" }}
            onClick={() => setDrawerOpen(false)}
          />
        )}

        {/* Mobile drawer */}
        <div className={`sidebar-drawer ${drawerOpen ? "open" : ""}`}>
          <div className="sidebar-drawer-header">
            <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
              <div style={{
                width: 30, height: 30, borderRadius: 8,
                background: "linear-gradient(135deg, var(--brand-primary), var(--brand-teal))",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <svg viewBox="0 0 64 64" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0" y="10" width="12" height="44" rx="3" fill="white"/>
                  <rect x="52" y="10" width="12" height="44" rx="3" fill="white"/>
                  <polyline
                    points="0,33 14,33 19,18 24,46 29,28 34,38 39,33 64,33"
                    fill="none" stroke="white" strokeWidth="5"
                    strokeLinecap="round" strokeLinejoin="round"
                  />
                </svg>
              </div>
              <div>
                <div style={{ fontFamily: "var(--font-display)", fontWeight: 600, fontSize: 15, color: "var(--brand-secondary)", lineHeight: 1.2 }}>FitMe</div>
                <div style={{ fontSize: 9, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.4px" }}>Care for your health</div>
              </div>
            </div>
            <button
              onClick={() => setDrawerOpen(false)}
              style={{
                width: 30, height: 30, border: "1px solid var(--border-color)",
                borderRadius: 8, background: "none", cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center",
                color: "var(--text-muted)", fontSize: 12,
              }}
            >
              <i className="pi pi-times" />
            </button>
          </div>
          <div className="drawer-pharmacy-selector">
            <PharmacySelector />
          </div>

          <PortalSidebar
            inDrawer
            onNavigate={() => setDrawerOpen(false)}
          />
        </div>

        <div className="portal-main">
          {children}
        </div>

        <PortalRightPanel />

      </div>

      {/* Phone verification modal — shown to Google users who haven't verified yet */}
      <PhoneVerifyModal />

      {/* Mobile bottom nav */}
      <MobileBottomNav />

    </div>
  );
}